import { render } from "./GoTopButton.vue?vue&type=template&id=0d1ebe8c&scoped=true"
import script from "./GoTopButton.vue?vue&type=script&lang=js"
export * from "./GoTopButton.vue?vue&type=script&lang=js"

import "./GoTopButton.vue?vue&type=style&index=0&id=0d1ebe8c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1ebe8c"]])

export default __exports__